import React, { useEffect, useState } from 'react'
import { ErrorMessages, triggerNotification, useGetApiRequests } from '../../common/CommonExport';
import { Modal, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { salaryUpdate } from '../../redux/salary-master/salaryAction';
import { ApiSuccessResponse } from '../../common/types';

import { SalaryDeleteModalProps } from './RegularEmployee/RegularEmployeeTypes';

const SalaryDeleteModal = (props: SalaryDeleteModalProps) => {
  const { open, editParticulars, handleClosed } = props;
  const saveSalaryMaster = useGetApiRequests('deleteSalaryMaster', 'DELETE');
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()
  const handelDelete = () => {
    setLoading(true);
    const queryParams = {
      "param": editParticulars.salaryComponentId,
    };
    saveSalaryMaster({}, {}, queryParams).then((response: unknown) => {
      const res = response as ApiSuccessResponse;
      setLoading(false);
      if (res) {
        dispatch(salaryUpdate(true))
        triggerNotification('success', '', res?.data?.status?.message || 'Salary Components Deleted Successfully', 'topRight');
        handleClosed()
      }
    })
      .catch((err: unknown) => {
        setLoading(false);
        console.error(err);
        handleClosed()
        triggerNotification('error', '', ErrorMessages.somethingWentWrong, 'topRight');
      });
  }
  useEffect(() => {
    setModalOpen(open)
  }, [open])

  const handelClose = () => {
    setModalOpen(false)
    handleClosed()
  }
  return (
    <Modal title='Delete' className='salaryStructure-modal' centered open={modalOpen} footer={null} onCancel={handelClose} maskClosable={!loading} keyboard={!loading} closable={!loading}>

      <div className='flex justify-end items-center gap-3 mr-2 salary_add-btn'>
        <p className='mb-0'>Are you sure you want to delete this ({editParticulars?.name}) in {editParticulars?.groupName}?</p>
        <div>
          <Button loading={loading} className='addButton min-w-[100px]' onClick={handelDelete}>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SalaryDeleteModal
